import { Dialog, IconButton } from "@mui/material";
import styled from "styled-components/macro";
import { StyledButton } from "../shared/Button/Button.styles";

export const CfcDialog = styled(Dialog)<{ $isConfirmationView?: boolean }>`
  .MuiDialog-paper {
    display: flex;
    flex-direction: column;
    max-width: ${({ $isConfirmationView }) =>
      $isConfirmationView ? "920px" : "1200px"};
    width: 100%;
    height: ${({ $isConfirmationView }) =>
      $isConfirmationView
        ? "min(784px, calc(100dvh - 64px))"
        : "min(852px, calc(100dvh - 64px))"};
    border-radius: 6px;
    overflow: hidden;

    @media (max-width: 800px) {
      margin: 12px;
      width: calc(100% - 24px);
      height: calc(100dvh - 24px);
    }
  }
`;

export const CfcHeader = styled.header`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  box-sizing: border-box;
  padding: 24px;
  background-color: ${({ theme }) => theme.neutral100};
  color: ${({ theme }) => theme.blueDark};

  @media (max-width: 800px) {
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
  }
`;

export const CfcHeaderTitle = styled.h1`
  margin: 0;
  font-family: bold;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.blueDark};

  @media (max-width: 800px) {
    font-size: 13px;
    line-height: 20px;
  }
`;

export const CfcCloseButton = styled(IconButton)`
  && {
    width: 24px;
    height: 24px;
    padding: 0;
    color: ${({ theme }) => theme.redMedium};
    font-size: 20px;
  }
`;

export const OrderModalLayout = styled.section`
  flex: 1 1 auto;
  display: flex;
  min-height: 0;
  background-color: ${({ theme }) => theme.neutral50};
  overflow: hidden;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const StepNavigationSidebar = styled.nav`
  width: 365px;
  min-width: 365px;
  background-color: ${({ theme }) => theme.neutral50};
  border-right: 1px solid ${({ theme }) => theme.neutral100};
  box-sizing: border-box;
  padding: 24px;

  @media (max-width: 800px) {
    width: 100%;
    min-width: 0;
    border-right: 0;
    border-bottom: 1px solid ${({ theme }) => theme.neutral100};
    padding: 16px;
  }
`;

export const CfcOrderingStepsTitle = styled.h2`
  margin: 0;
  padding-bottom: 16px;
  font-size: 18px;
  line-height: 28px;
  font-family: light;
  color: ${({ theme }) => theme.greyDark};

  @media (max-width: 800px) {
    padding-bottom: 8px;
  }
`;

export const CfcStepList = styled.ol`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const CfcStepItem = styled.li<{ $active: boolean }>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 45px;
  padding-right: 16px;
  gap: 10px;
  cursor: default;
  font-size: 21px;
  line-height: 20px;
  font-family: bold;
  text-transform: uppercase;
  color: ${({ $active, theme }) =>
    $active ? theme.redMedium : theme.greyMedium};
  white-space: normal;

  @media (max-width: 800px) {
    min-height: 36px;
    font-size: 16px;
  }
`;

export const StepCircle = styled.span<{ $active: boolean }>`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${({ $active, theme }) =>
    $active ? theme.redMedium : theme.greyMedium};
  font-size: 15px;
`;

export const OrderStepContentArea = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background-color: ${({ theme }) => theme.white};
  overflow: hidden;
`;

export const ScrollableSection = styled.section`
  flex: 1;
  min-height: 0;
  padding: 24px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 800px) {
    padding: 20px 16px;
  }
`;

export const CfcFooter = styled.footer<{ $isConfirmationView?: boolean }>`
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px 24px;
  background-color: ${({ $isConfirmationView, theme }) =>
    $isConfirmationView ? theme.neutral50 : theme.white};
  border-top: ${({ $isConfirmationView, theme }) =>
    $isConfirmationView ? `1px solid ${theme.neutral100}` : "0"};

  ${StyledButton} {
    height: 44px !important;
  }

  @media (max-width: 800px) {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    padding: 12px 16px;
  }
`;

export const CfcFooterRight = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;

  @media (max-width: 800px) {
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    margin-left: 0;
  }
`;

export const CfcSubmitError = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.redMedium};
  font-size: 0.875rem;
`;
